var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-avatar',{staticClass:"avatar",attrs:{"size":_vm.size,"src":_vm.src}},[_c('div',{staticClass:"default"},[_vm._v(_vm._s(_vm.placeholder))])])
}
var staticRenderFns = []

export { render, staticRenderFns }